import React, { ReactElement, Fragment } from 'react'
import { useSelector } from 'react-redux'
import { fontSize as fontSizeBase } from '@partipost-cm-new/app-preview/dist/Styles/Base'
import PartiText from '@partipost-cm-new/app-preview/dist/Components/PartiText'
import { StyleProp, View, ViewStyle } from 'react-native'
import { createGetConstantsByKey } from 'state'
import Icon from 'particles/Icon'

export enum CampaignCategory {
    FASHION = 1,
    FOOD,
    EVENTS,
    SPORTS,
    TECH,
    BEAUTY,
    OTHERS = 99,
}

interface CategoryIconListProps {
    categories: CampaignCategory[]
    color: string
    fontSize?: number
    itemContainerStyle?: StyleProp<ViewStyle>
}

const CategoryIconList: React.FC<CategoryIconListProps> = ({
    categories,
    color,
    fontSize = fontSizeBase.extraSmall,
    itemContainerStyle,
}): ReactElement | null => {
    const campaignConstants = useSelector(createGetConstantsByKey('campaign'))
    const commonDataCategories = campaignConstants.campaign_categories
    return React.createElement(
        Fragment,
        null,
        <View style={itemContainerStyle}>
            {categories && categories.length > 0 && commonDataCategories
                ? categories.sort().map((item, index) => {
                      const categoryData = commonDataCategories.find(
                          (category: { id: number; label: string }) => category.id === item,
                      )
                      return categoryData ? (
                          <Fragment key={categoryData.label}>
                              <View>
                                  <PartiText style={{ color, fontSize }}>{categoryData.label}</PartiText>
                              </View>
                              {index < categories.length - 1 && (
                                  <Icon size="16px" name={'dot'} color={'neutralActionActive'} />
                              )}
                          </Fragment>
                      ) : null
                  })
                : null}
        </View>,
    )
}

export default CategoryIconList
